

// @ts-nocheck

import type { ReactNode } from "react";
import React from 'react';
import {
  FaPaw, FaBone, FaFish, FaCat, FaDog,
  FaShirt, FaShoePrints, FaBagShopping, FaGem, FaRing,
  FaPalette, FaMusic, FaTicketSimple, FaBook, FaMasksTheater,
  FaBaby, FaBabyCarriage,
  FaIndustry, FaWarehouse, FaTruck, FaHelmetSafety,
  FaCamera, FaVideo, FaBinoculars,
  FaLaptop, FaMobileScreenButton, FaHeadphones, FaTv, FaPlug,
  FaAppleWhole, FaWineBottle, FaMugSaucer, FaCookieBite, FaSmoking,
  FaCouch, FaBed, FaChair, FaLightbulb,
  FaScrewdriverWrench, FaHammer, FaWrench, FaScrewdriver, FaPaintRoller,
  FaSpa, FaPumpSoap, FaScissors, FaWandMagicSparkles,
  FaLeaf, FaTree, FaSeedling, FaPersonSwimming, FaUmbrellaBeach,
  FaSuitcase, FaSuitcaseRolling, FaBriefcase,
  FaTriangleExclamation,
  FaFilm, FaCompactDisc, FaGuitar,
  FaPaperclip, FaPen, FaFolder, FaPrint,
  FaCross, FaStar, FaDove,
  FaCode, FaLaptopCode, FaCloud,
  FaFutbol, FaDumbbell, FaPersonBiking, FaPersonRunning, FaCampground,
  FaGamepad, FaChess, FaPuzzlePiece, FaChild,
  FaCar, FaMotorcycle, FaCarBattery, FaCarSide,
  FaGift,
  FaCircleQuestion,
  FaBellConcierge, FaHandshakeAngle, FaTruckFast,
  FaSquarePlus,
  FaBoxesStacked, FaLayerGroup,
  FaVest, FaMitten,
  FaBolt,
  FaCrown,
  FaHeart,
  FaTag,FaTractor,FaUtensils,FaCartShopping,FaKitchenSet,
} from "react-icons/fa6";
import { FaSnowflake, FaWind } from "react-icons/fa";
import { SiSimpleicons } from "react-icons/si";





export type AttributeInput = "select" | "multiselect" | "text" | "number" | "color";

export interface Attribute {
  id: number;
  name: string;
  inputType?: AttributeInput;   // default "select"
  required?: boolean;
  unit?: string;                // for number inputs, e.g. "ml", "kg"
  options: AttributeOption[];   // [] for free-text / number
}

export interface CategoryItem {
  id: string;
  parentId: string | null;
  level: "department" | "category" | "subCategory" | "productType" | "product";
  name: string;
  icon?: ReactNode;
  attributes?: Attribute[];
  children?: CategoryItem[];
   image?: any;
   hexCodes?: string[];
}


export interface AttributeOption {
  id: number;
  standard: string;
  standard?: string; eu?: string; uk?: string; us?: string;
  waist?: string; hips?: string; height?: string; inseam?: string;
  // colors / screens / misc
  hex?: string; inches?: string; cm?: string; symbol?: string;
  inseam?: string;  // inches
  hex?: string; inches?: string; cm?: string; symbol?: string;
}

export interface AttributeGroup {
  id: number;
  name: string;
  options: AttributeOption[];
}



interface UnitItem {
  id: number;
  name: string;
  symbol?: string;
}

interface UnitCategory {
  id: string;
  name: string;
  units: UnitItem[];
}

export const Units: UnitCategory[] = [
  /* ───── LENGTH ───── */
  {
    id: "length",
    name: "Length",
    units: [
      { id: 1001, name: "Meter", symbol: "m" },
      { id: 1002, name: "Centimeter", symbol: "cm" },
      { id: 1003, name: "Millimeter", symbol: "mm" },
      { id: 1004, name: "Foot", symbol: "ft" },
      { id: 1005, name: "Inch", symbol: "in" },
    ],
  },

  /* ───── MASS ───── */
  {
    id: "mass",
    name: "Mass",
    units: [
      { id: 2001, name: "Kilogram", symbol: "kg" },
      { id: 2002, name: "Tonne", symbol: "t" },
      { id: 2003, name: "Gram", symbol: "g" },
      { id: 2004, name: "Pound-mass", symbol: "lbm" },
      { id: 2005, name: "Slug", symbol: "sl" },
      { id: 2006, name: "Deciliter", symbol: "dL" },
    ],
  },

  /* ───── ENERGY ───── */
  {
    id: "energy",
    name: "Energy",
    units: [
      { id: 3001, name: "Joule", symbol: "J" },
      { id: 3002, name: "Kilojoule", symbol: "kJ" },
      { id: 3003, name: "BTU", symbol: "Btu" },
      { id: 3004, name: "Foot-pound force", symbol: "ft·lbf" },
      { id: 3005, name: "Calorie", symbol: "cal" },
    ],
  },

  /* ───── MODULUS / STRESS ───── */
  {
    id: "modulus_stress",
    name: "Modulus/Stress",
    units: [
      { id: 4001, name: "Pascal", symbol: "Pa" },
      { id: 4002, name: "Kilopascal", symbol: "kPa" },
      { id: 4003, name: "Megapascal", symbol: "MPa" },
      { id: 4004, name: "Kilogram per square centimeter", symbol: "kg/cm²" },
      { id: 4005, name: "PSI", symbol: "psi" },
      { id: 4006, name: "KSI", symbol: "ksi" },
      { id: 4007, name: "PSF", symbol: "psf" },
    ],
  },

  /* ───── FORCE ───── */
  {
    id: "force",
    name: "Force",
    units: [
      { id: 5001, name: "Newton", symbol: "N" },
      { id: 5002, name: "Kilonewton", symbol: "kN" },
      { id: 5003, name: "Meganewton", symbol: "MN" },
      { id: 5004, name: "Kilogram-force", symbol: "kgf" },
      { id: 5005, name: "Pound-force", symbol: "lbf" },
      { id: 5006, name: "Kip", symbol: "kip" },
    ],
  },

  /* ───── TEMPERATURE ───── */
  {
    id: "temperature",
    name: "Temperature",
    units: [
      { id: 6001, name: "Celsius", symbol: "°C" },
      { id: 6002, name: "Fahrenheit", symbol: "°F" },
      { id: 6003, name: "Kelvin", symbol: "K" },
      { id: 6004, name: "Rankine", symbol: "°R" },
    ],
  },

  /* ───── TIME ───── */
  {
    id: "time",
    name: "Time",
    units: [
      { id: 7001, name: "Second", symbol: "s" },
    ],
  },

  /* ───── DENSITY ───── */
  {
    id: "density",
    name: "Density",
    units: [
      { id: 8001, name: "Kilogram per cubic meter", symbol: "kg/m³" },
    ],
  },

  /* ───── CONDUCTIVITY ───── */
  {
    id: "conductivity",
    name: "Conductivity",
    units: [
      { id: 9001, name: "Joule per second centimeter Kelvin", symbol: "J/(s·cm·K)" },
    ],
  },

  /* ───── SPECIFIC HEAT ───── */
  {
    id: "specific_heat",
    name: "Specific Heat",
    units: [
      { id: 10001, name: "Joule per kilogram Kelvin", symbol: "J/(kg·K)" },
    ],
  },

  /* ───── FLUX ───── */
  {
    id: "flux",
    name: "Flux",
    units: [
      { id: 11001, name: "Joule per second square meter", symbol: "J/(s·m²)" },
    ],
  },

  /* ───── CONVECTION ───── */
  {
    id: "convection",
    name: "Convection",
    units: [
      { id: 12001, name: "Joule per second square meter Kelvin", symbol: "J/(s·m²·K)" },
    ],
  },

  /* ───── PRESETS ───── */
  {
    id: "presets",
    name: "Presets",
    units: [
      { id: 13001, name: "SI" },
      { id: 13002, name: "N·mm" },
      { id: 13003, name: "IPS" },
      { id: 13004, name: "kN·m" },
      { id: 13005, name: "EPS" },
      { id: 13006, name: "kg·cm" },
      { id: 13007, name: "User" },
    ],
  },
];


/* ═══════════════════════════════════════════════════════════
   📦 PACKAGING TYPE
═══════════════════════════════════════════════════════════ */
export const PackagingTypes: AttributeItem[] = [
  { id: 90301, name: "Loose",   icon: <FaBoxesStacked size={14} /> },
  { id: 90302, name: "Bag",     icon: <FaBoxesStacked size={14} /> },
  { id: 90303, name: "Box",     icon: <FaBoxesStacked size={14} /> },
  { id: 90304, name: "Jar",     icon: <FaSquarePlus size={14} /> },
  { id: 90305, name: "Bottle",  icon: <FaVest size={14} /> },
  { id: 90306, name: "Can",     icon: <FaTag size={14} /> },
  { id: 90307, name: "Pouch",   icon: <FaMitten size={14} /> },
  { id: 90308, name: "Tray",    icon: <FaLayerGroup size={14} /> },
  { id: 90309, name: "Carton",  icon: <FaBoxesStacked size={14} /> },
  { id: 90310, name: "Wrapped", icon: <FaTag size={14} /> },
];







export const Colors: CategoryItem[] = [
  /* ───── NEUTRALS ───── */
  { id: 9000110, name: "Off White",     hexCodes: ["#F8F8F0"] },
  { id: 9000111, name: "Pearl",         hexCodes: ["#EAE0C8"] },
  { id: 9000112, name: "Stone",         hexCodes: ["#B8B5A9"] },
  { id: 9000113, name: "Taupe",         hexCodes: ["#483C32"] },
  { id: 9000114, name: "Sand",          hexCodes: ["#C2B280"] },
  { id: 9000115, name: "Khaki",         hexCodes: ["#C3B091"] },
  { id: 9000116, name: "Camel",         hexCodes: ["#C19A6B"] },
  { id: 9000117, name: "Mocha",         hexCodes: ["#967969"] },
  { id: 9000118, name: "Chocolate",     hexCodes: ["#7B3F00"] },
  { id: 9000119, name: "Espresso",      hexCodes: ["#4B3621"] },

  /* ───── BLACK & WHITE / GRAYSCALE ───── */
  { id: 9001101, name: "Black",         hexCodes: ["#000000"] },
  { id: 9001102, name: "Licorice",      hexCodes: ["#0C0C0C"] },
  { id: 9001103, name: "Jet Black",     hexCodes: ["#191919"] },
  { id: 9001104, name: "Graphite",      hexCodes: ["#262626"] },
  { id: 9001105, name: "Charcoal",      hexCodes: ["#323232"] },
  { id: 9001106, name: "Dark Gray",     hexCodes: ["#4C4C4C"] },
  { id: 9001107, name: "Ash Gray",      hexCodes: ["#666666"] },
  { id: 9001108, name: "Medium Gray",   hexCodes: ["#7F7F7F"] },
  { id: 9001109, name: "Silver Gray",   hexCodes: ["#999999"] },
  { id: 9001110, name: "Light Gray",    hexCodes: ["#B2B2B2"] },
  { id: 9001111, name: "Gainsboro",     hexCodes: ["#CCCCCC"] },
  { id: 9001112, name: "Smoke",         hexCodes: ["#E5E5E5"] },
  { id: 9001113, name: "White",         hexCodes: ["#FFFFFF"] },

  /* ───── REDS ───── */
  { id: 9000401, name: "Pure Red",       hexCodes: ["#FF0000"] },
  { id: 9000402, name: "Vivid Red",      hexCodes: ["#E60000"] },
  { id: 9000403, name: "True Red",       hexCodes: ["#CF0101"] },
  { id: 9000404, name: "Bold Red",       hexCodes: ["#C00000"] },
  { id: 9000405, name: "Dark Red",       hexCodes: ["#A60202"] },
  { id: 9000416, name: "Light Coral",    hexCodes: ["#FF8B8E"] },
  { id: 9000417, name: "Neon Red",       hexCodes: ["#FF3D41"] },
  { id: 9000418, name: "Firetruck Red",  hexCodes: ["#DC0005"] },
  { id: 9000419, name: "Deep Red",       hexCodes: ["#C80004"] },
  { id: 9000420, name: "Maroon",         hexCodes: ["#B40000"] },
  { id: 9000421, name: "Burgundy",       hexCodes: ["#690000"] },
  { id: 9000422, name: "Flame Red",      hexCodes: ["#E31919"] },
  { id: 9000423, name: "Vermilion",      hexCodes: ["#EA2300"] },
  { id: 9000424, name: "Ruby Red",       hexCodes: ["#DD1212"] },
  { id: 9000425, name: "Bright Red",     hexCodes: ["#F02525"] },
  { id: 9000426, name: "Hot Red",        hexCodes: ["#EA0A0A"] },
  { id: 9000427, name: "Candy Red",      hexCodes: ["#DD1717"] },
  { id: 9000428, name: "Tomato Red",     hexCodes: ["#FB3310"] },
  { id: 9000429, name: "Rose Red",       hexCodes: ["#F40D30"] },
  { id: 9000430, name: "Cardinal",       hexCodes: ["#C70E0E"] },
  { id: 9000431, name: "Raspberry",      hexCodes: ["#D6204E"] },
  { id: 9000406, name: "Crimson",        hexCodes: ["#DC143C"] },
  { id: 9000407, name: "Scarlet",        hexCodes: ["#FF2400"] },
  { id: 9000408, name: "Cherry Red",     hexCodes: ["#D2042D"] },
  { id: 9000409, name: "Wine",           hexCodes: ["#722F37"] },
  { id: 9000410, name: "Coral",          hexCodes: ["#FF7F50"] },
  { id: 9000411, name: "Salmon",         hexCodes: ["#FA8072"] },
  { id: 9000412, name: "Blush Pink",     hexCodes: ["#F4C2C2"] },
  { id: 9000413, name: "Hot Pink",       hexCodes: ["#FF69B4"] },
  { id: 9000414, name: "Fuchsia",        hexCodes: ["#FF00FF"] },
  { id: 9000415, name: "Magenta",        hexCodes: ["#D1007A"] },

  /* ───── PINKS ───── */
  { id: 9001201, name: "Electric Pink",  hexCodes: ["#FB00BE"] },
  { id: 9001202, name: "Neon Pink",      hexCodes: ["#FF0074"] },
  { id: 9001203, name: "Bright Pink",    hexCodes: ["#FF00CE"] },
  { id: 9001204, name: "Deep Pink",      hexCodes: ["#FF07A9"] },
  { id: 9001205, name: "Cerise",         hexCodes: ["#EE006C"] },

  /* ───── BERRY ───── */
  { id: 9001301, name: "Plum Berry",     hexCodes: ["#990F4B"] },
  { id: 9001302, name: "Mulberry",       hexCodes: ["#AD3D5E"] },
  { id: 9001303, name: "Dusty Rose",     hexCodes: ["#C05F72"] },
  { id: 9001304, name: "Mauve Pink",     hexCodes: ["#D27F87"] },
  { id: 9001305, name: "Blush Berry",    hexCodes: ["#E39E9C"] },

  /* ───── ORANGES & YELLOWS ───── */
  { id: 9000505, name: "Peach",          hexCodes: ["#FFE5B4"] },
  { id: 9000506, name: "Apricot",        hexCodes: ["#FBCEB1"] },
  { id: 9000507, name: "Tangerine",      hexCodes: ["#F28500"] },
  { id: 9000508, name: "Burnt Orange",   hexCodes: ["#CC5500"] },
  { id: 9000509, name: "Rust",           hexCodes: ["#B7410E"] },
  { id: 9000510, name: "Golden Yellow",  hexCodes: ["#FFDF00"] },
  { id: 9000511, name: "Lemon",          hexCodes: ["#FFF44F"] },
  { id: 9000512, name: "Canary Yellow",  hexCodes: ["#FFEF00"] },
  { id: 9000513, name: "Sunflower",      hexCodes: ["#FFC512"] },

  /* ───── ORANGES (EXTENDED) ───── */
  { id: 9001401, name: "Burnt Sienna",   hexCodes: ["#C65102"] },
  { id: 9001402, name: "Amber Orange",   hexCodes: ["#D56602"] },
  { id: 9001403, name: "Dark Amber",     hexCodes: ["#E37B01"] },
  { id: 9001404, name: "Deep Amber",     hexCodes: ["#F19001"] },
  { id: 9001405, name: "Orange",         hexCodes: ["#FFA500"] },
  { id: 9001406, name: "Pale Orange",    hexCodes: ["#FDCC99"] },
  { id: 9001407, name: "Warm Orange",    hexCodes: ["#FB9932"] },
  { id: 9001408, name: "Pumpkin",        hexCodes: ["#FA8000"] },
  { id: 9001409, name: "Bronze Orange",  hexCodes: ["#C86600"] },
  { id: 9001410, name: "Dark Pumpkin",   hexCodes: ["#7D4000"] },

  /* ───── YELLOWS (EXTENDED) ───── */
  { id: 9001501, name: "Pale Yellow",    hexCodes: ["#FCF5B2"] },
  { id: 9001502, name: "Soft Yellow",    hexCodes: ["#FBEE7F"] },
  { id: 9001503, name: "Bright Yellow",  hexCodes: ["#F9E432"] },
  { id: 9001504, name: "Pure Yellow",    hexCodes: ["#F8DE00"] },
  { id: 9001505, name: "Gold Yellow",    hexCodes: ["#DFC700"] },
  { id: 9001506, name: "Cream Yellow",   hexCodes: ["#FFFBA0"] },
  { id: 9001507, name: "Butter",         hexCodes: ["#FFEC8E"] },
  { id: 9001508, name: "Straw",          hexCodes: ["#FEE283"] },
  { id: 9001509, name: "Honey",          hexCodes: ["#F6D484"] },
  { id: 9001510, name: "Warm Honey",     hexCodes: ["#EFC576"] },

  /* ───── GREENS ───── */
  { id: 9000305, name: "Emerald",        hexCodes: ["#50C878"] },
  { id: 9000306, name: "Jade",           hexCodes: ["#00A86B"] },
  { id: 9000307, name: "Sage",           hexCodes: ["#9CAF88"] },
  { id: 9000308, name: "Moss Green",     hexCodes: ["#8A9A5B"] },
  { id: 9000309, name: "Army Green",     hexCodes: ["#4B5320"] },
  { id: 9000310, name: "Pistachio",      hexCodes: ["#93C572"] },
  { id: 9000311, name: "Sea Green",      hexCodes: ["#2E8B57"] },
  { id: 9000312, name: "Kelly Green",    hexCodes: ["#4CBB17"] },
  { id: 9000313, name: "Neon Green",     hexCodes: ["#39FF14"] },
  { id: 9000314, name: "Dark Green",     hexCodes: ["#006400"] },

  /* ───── GREENS (EXTENDED) ───── */
  { id: 9001601, name: "Mint",           hexCodes: ["#CDF5D2"] },
  { id: 9001602, name: "Spring Green",   hexCodes: ["#69E279"] },
  { id: 9001603, name: "Vivid Green",    hexCodes: ["#04A519"] },
  { id: 9001604, name: "Forest Green",   hexCodes: ["#049016"] },
  { id: 9001605, name: "Deep Forest",    hexCodes: ["#013E09"] },
  { id: 9001606, name: "Lime Green",     hexCodes: ["#00FF00"] },
  { id: 9001607, name: "Bright Lime",    hexCodes: ["#05C800"] },
  { id: 9001608, name: "Grass Green",    hexCodes: ["#069300"] },
  { id: 9001609, name: "Fern",           hexCodes: ["#056200"] },
  { id: 9001610, name: "Pine",           hexCodes: ["#033500"] },
  { id: 9001611, name: "Laurel",         hexCodes: ["#AAD688"] },
  { id: 9001612, name: "Artichoke",      hexCodes: ["#98C377"] },
  { id: 9001613, name: "Herb Green",     hexCodes: ["#8BBD78"] },
  { id: 9001614, name: "Leaf Green",     hexCodes: ["#5EA758"] },
  { id: 9001615, name: "Dark Sage",      hexCodes: ["#47894B"] },
  { id: 9001616, name: "Neon Lime",      hexCodes: ["#76FF7B"] },
  { id: 9001617, name: "Lime Punch",     hexCodes: ["#A1FF7B"] },
  { id: 9001618, name: "Green Yellow",   hexCodes: ["#C4FF7B"] },
  { id: 9001619, name: "Yellow Lime",    hexCodes: ["#E3FF7A"] },
  { id: 9001620, name: "Lemon Lime",     hexCodes: ["#FFFE7A"] },

  /* ───── BLUES ───── */
  { id: 9000206, name: "Baby Blue",      hexCodes: ["#89CFF0"] },
  { id: 9000207, name: "Powder Blue",    hexCodes: ["#B0E0E6"] },
  { id: 9000208, name: "Steel Blue",     hexCodes: ["#4682B4"] },
  { id: 9000209, name: "Denim Blue",     hexCodes: ["#1560BD"] },
  { id: 9000210, name: "Cobalt Blue",    hexCodes: ["#0047AB"] },
  { id: 9000211, name: "Sapphire",       hexCodes: ["#0F52BA"] },
  { id: 9000212, name: "Aqua",           hexCodes: ["#00FFFF"] },
  { id: 9000213, name: "Cyan",           hexCodes: ["#00BCD4"] },
  { id: 9000214, name: "Petrol Blue",    hexCodes: ["#005F6A"] },
  { id: 9000215, name: "Ice Blue",       hexCodes: ["#D6F5FF"] },

  /* ───── BLUES (EXTENDED) ───── */
  { id: 9001701, name: "Midnight Blue",  hexCodes: ["#040273"] },
  { id: 9001702, name: "Navy",           hexCodes: ["#022477"] },
  { id: 9001703, name: "Royal Navy",     hexCodes: ["#0E3879"] },
  { id: 9001704, name: "Dark Blue",      hexCodes: ["#1F4A7C"] },
  { id: 9001705, name: "Ocean Blue",     hexCodes: ["#315B7D"] },
  { id: 9001706, name: "Cornflower",     hexCodes: ["#5170D7"] },
  { id: 9001707, name: "Periwinkle",     hexCodes: ["#6E8CDC"] },
  { id: 9001708, name: "Muted Blue",     hexCodes: ["#8DA6DF"] },
  { id: 9001709, name: "Sky Blue",       hexCodes: ["#1A84B8"] },
  { id: 9001710, name: "Azure",          hexCodes: ["#1A8CB8"] },
  { id: 9001711, name: "Cerulean",       hexCodes: ["#1A94B8"] },
  { id: 9001712, name: "Peacock Blue",   hexCodes: ["#1A9CB8"] },
  { id: 9001713, name: "Lagoon Blue",    hexCodes: ["#1AA4B8"] },

  /* ───── BLUE GRAY ───── */
  { id: 9001801, name: "Slate Blue",     hexCodes: ["#758DA3"] },
  { id: 9001802, name: "Storm Blue",     hexCodes: ["#859CB2"] },
  { id: 9001803, name: "Dusty Blue",     hexCodes: ["#95ABC2"] },
  { id: 9001804, name: "Glacier Blue",   hexCodes: ["#A6BAD2"] },
  { id: 9001805, name: "Pale Steel",     hexCodes: ["#B7C9E2"] },

  /* ───── DENIM ───── */
  { id: 9001901, name: "Dark Denim",     hexCodes: ["#071F35"] },
  { id: 9001902, name: "Indigo Denim",   hexCodes: ["#24496B"] },
  { id: 9001903, name: "Medium Denim",   hexCodes: ["#446D92"] },
  { id: 9001904, name: "Faded Denim",    hexCodes: ["#98B1C8"] },
  { id: 9001905, name: "Washed Denim",   hexCodes: ["#F7FAFE"] },

  /* ───── AQUA BLUE ───── */
  { id: 9002001, name: "Soft Aqua",      hexCodes: ["#90C0E0"] },
  { id: 9002002, name: "Light Aqua",     hexCodes: ["#80B8D8"] },
  { id: 9002003, name: "Vivid Aqua",     hexCodes: ["#3890C8"] },
  { id: 9002004, name: "Bright Aqua",    hexCodes: ["#60A8D0"] },
  { id: 9002005, name: "Pale Aqua",      hexCodes: ["#98C8E0"] },

  /* ───── CYAN ───── */
  { id: 9002101, name: "Electric Cyan",  hexCodes: ["#00FFFF"] },
  { id: 9002102, name: "Bright Cyan",    hexCodes: ["#00E1E1"] },
  { id: 9002103, name: "Medium Cyan",    hexCodes: ["#00C3C3"] },
  { id: 9002104, name: "Deep Cyan",      hexCodes: ["#00A7A7"] },
  { id: 9002105, name: "Dark Teal",      hexCodes: ["#008B8B"] },

  /* ───── PURPLES ───── */
  { id: 9000604, name: "Violet",         hexCodes: ["#8F00FF"] },
  { id: 9000605, name: "Lilac",          hexCodes: ["#C8A2C8"] },
  { id: 9000606, name: "Mauve",          hexCodes: ["#E0B0FF"] },
  { id: 9000607, name: "Orchid",         hexCodes: ["#DA70D6"] },
  { id: 9000608, name: "Eggplant",       hexCodes: ["#614051"] },
  { id: 9000609, name: "Deep Purple",    hexCodes: ["#512DA8"] },

  /* ───── PURPLES (EXTENDED) ───── */
  { id: 9002201, name: "Electric Purple", hexCodes: ["#B700FF"] },
  { id: 9002202, name: "Vivid Purple",   hexCodes: ["#9A00D6"] },
  { id: 9002203, name: "Grape",          hexCodes: ["#7900A8"] },
  { id: 9002204, name: "Dark Grape",     hexCodes: ["#600085"] },
  { id: 9002205, name: "Blackberry",     hexCodes: ["#300042"] },

  /* ───── VIOLET / LAVENDER ───── */
  { id: 9002301, name: "Soft Violet",    hexCodes: ["#D6B4FC"] },
  { id: 9002302, name: "Wisteria",       hexCodes: ["#E0BCF5"] },
  { id: 9002303, name: "Lavender",       hexCodes: ["#EAC3EE"] },
  { id: 9002304, name: "Pale Lavender",  hexCodes: ["#F4CAE7"] },
  { id: 9002305, name: "Blush Lavender", hexCodes: ["#FFD1DF"] },

  /* ───── INDIGO ───── */
  { id: 9002401, name: "Midnight Indigo", hexCodes: ["#191970"] },
  { id: 9002402, name: "Royal Indigo",   hexCodes: ["#002395"] },
  { id: 9002403, name: "Dark Indigo",    hexCodes: ["#00416A"] },
  { id: 9002404, name: "Indigo Blue",    hexCodes: ["#1560BD"] },
  { id: 9002405, name: "Soft Indigo",    hexCodes: ["#5D76CB"] },

  /* ───── TRUE COLORS / HERITAGE ───── */
  { id: 9002501, name: "Deep Crimson",   hexCodes: ["#830000"] },
  { id: 9002502, name: "Dark Sienna",    hexCodes: ["#8B4D00"] },
  { id: 9002503, name: "Olive Drab",     hexCodes: ["#666700"] },
  { id: 9002504, name: "Hunter Green",   hexCodes: ["#00510E"] },
  { id: 9002505, name: "Midnight Navy",  hexCodes: ["#000440"] },

  /* ───── BROWNS ───── */
  { id: 9000901, name: "Tan",            hexCodes: ["#D2B48C"] },
  { id: 9000902, name: "Chestnut",       hexCodes: ["#954535"] },
  { id: 9000903, name: "Walnut",         hexCodes: ["#5D432C"] },
  { id: 9000904, name: "Mahogany",       hexCodes: ["#C04000"] },
  { id: 9000905, name: "Cocoa",          hexCodes: ["#6F4E37"] },

  /* ───── BROWNS (EXTENDED) ───── */
  { id: 9002601, name: "Sandy Brown",    hexCodes: ["#FA9755"] },
  { id: 9002602, name: "Warm Brown",     hexCodes: ["#C77844"] },
  { id: 9002603, name: "Hazel",          hexCodes: ["#87522E"] },
  { id: 9002604, name: "Umber",          hexCodes: ["#7B4B2A"] },
  { id: 9002605, name: "Toffee",         hexCodes: ["#613B21"] },
  { id: 9002606, name: "Dark Toffee",    hexCodes: ["#553311"] },
  { id: 9002607, name: "Auburn Brown",   hexCodes: ["#664433"] },
  { id: 9002608, name: "Seal Brown",     hexCodes: ["#332211"] },
  { id: 9002609, name: "Caramel",        hexCodes: ["#996633"] },
  { id: 9002610, name: "Warm Caramel",   hexCodes: ["#CCAA66"] },
  { id: 9002611, name: "Ginger",         hexCodes: ["#CC8833"] },
  { id: 9002612, name: "Cognac",         hexCodes: ["#D08C42"] },
  { id: 9002613, name: "Whiskey",        hexCodes: ["#D4914F"] },
  { id: 9002614, name: "Teak",           hexCodes: ["#D9955B"] },
  { id: 9002615, name: "Butterscotch",   hexCodes: ["#DD9966"] },

  /* ───── CHESTNUTS ───── */
  { id: 9002701, name: "Dark Chestnut",  hexCodes: ["#742802"] },
  { id: 9002702, name: "Russet",         hexCodes: ["#8F4934"] },
  { id: 9002703, name: "Clay",           hexCodes: ["#A96A5C"] },
  { id: 9002704, name: "Rosy Brown",     hexCodes: ["#C38B85"] },
  { id: 9002705, name: "Pale Chestnut",  hexCodes: ["#DDADAF"] },

  /* ───── METALLICS ───── */
  { id: 9000701, name: "Gold",           hexCodes: ["#D4AF37"] },
  { id: 9000702, name: "Rose Gold",      hexCodes: ["#B76E79"] },
  { id: 9000703, name: "Copper",         hexCodes: ["#B87333"] },
  { id: 9000704, name: "Bronze",         hexCodes: ["#CD7F32"] },
  { id: 9000705, name: "Gunmetal",       hexCodes: ["#2A3439"] },
  { id: 9000706, name: "Titanium",       hexCodes: ["#878681"] },
  { id: 9000707, name: "Platinum",       hexCodes: ["#E5E4E2"] },
  { id: 9000708, name: "Chrome",         hexCodes: ["#D7D7D7"] },

  /* ───── PASTELS ───── */
  { id: 9001001, name: "Pastel Blue",    hexCodes: ["#AEC6CF"] },
  { id: 9001002, name: "Pastel Green",   hexCodes: ["#77DD77"] },
  { id: 9001003, name: "Pastel Pink",    hexCodes: ["#FFD1DC"] },
  { id: 9001004, name: "Pastel Yellow",  hexCodes: ["#FDFD96"] },
  { id: 9001005, name: "Pastel Purple",  hexCodes: ["#C3B1E1"] },

  /* ───── SPECIAL / MIXED ───── */
  { id: 9000801, name: "Multicolor" },
  { id: 9000802, name: "Transparent" },
  { id: 9000803, name: "Matte Black",    hexCodes: ["#1C1C1C"] },
  { id: 9000804, name: "Glossy White",   hexCodes: ["#FAFAFA"] },

  /* ───── SPECIAL EFFECTS ───── */
  { id: 9000805, name: "Rainbow" },
  { id: 9000806, name: "Iridescent" },
  { id: 9000807, name: "Holographic" },
  { id: 9000808, name: "Metallic" },
  { id: 9000809, name: "Glow in the Dark" },
  { id: 9000810, name: "Clear",          hexCodes: ["#FFFFFF"] },
];

/* ═══════════════════════════════════════════════════════════
   1. AGES
═══════════════════════════════════════════════════════════ */
export const AgeRanges: AttributeItem[] = [
  { id: 1001, name: "0–1 month",   icon: <FaGift size={16} /> },
  { id: 1002, name: "1–3 months",  icon: <FaGift size={16} /> },
  { id: 1003, name: "3–6 months",  icon: <FaGift size={16} /> },
  { id: 1004, name: "6–9 months",  icon: <FaGift size={16} /> },
  { id: 1005, name: "9–12 months", icon: <FaGift size={16} /> },
  { id: 1006, name: "12–18 months",icon: <FaGift size={16} /> },
  { id: 1007, name: "18–24 months",icon: <FaGift size={16} /> },
  { id: 1008, name: "2–3 years",   icon: <FaCrown size={16} /> },
  { id: 1009, name: "3–4 years",   icon: <FaCrown size={16} /> },
  { id: 1010, name: "4–5 years",   icon: <FaCrown size={16} /> },
  { id: 1011, name: "5–6 years",   icon: <FaCrown size={16} /> },
  { id: 1012, name: "6–7 years",   icon: <FaCrown size={16} /> },
  { id: 1013, name: "7–8 years",   icon: <FaCrown size={16} /> },
  { id: 1014, name: "8–9 years",   icon: <FaCrown size={16} /> },
  { id: 1015, name: "9–10 years",  icon: <FaCrown size={16} /> },
  { id: 1016, name: "10–11 years", icon: <FaCrown size={16} /> },
  { id: 1017, name: "11–12 years", icon: <FaCrown size={16} /> },
  { id: 1018, name: "12–13 years", icon: <FaHeart size={16} /> },
  { id: 1019, name: "13–14 years", icon: <FaHeart size={16} /> },
  { id: 1020, name: "14–15 years", icon: <FaHeart size={16} /> },
  { id: 1021, name: "15–16 years", icon: <FaHeart size={16} /> },
];


/* ───────────────────────────────────────────────────────────
   DEPARTMENTS  (level 1 — top of tree, parentId: null)
   All ids standardized to 3-digit codes: "000" .. "020"
   ─────────────────────────────────────────────────────────── */
export const DEPARTMENTSATTRIBUTES: CategoryItem[] = [
  { id: "000", parentId: null, level: "department", name: "ArtCrafts",   icon: <FaPalette /> },
  { id: "001", parentId: null, level: "department", name: "Automotive",  icon: <FaCar /> },
  { id: "002", parentId: null, level: "department", name: "Aviation",    icon: <FaPlug /> },
  { id: "003", parentId: null, level: "department", name: "Baby",        icon: <FaBaby /> },
  { id: "004", parentId: null, level: "department", name: "Beauty",      icon: <FaSpa /> },
  { id: "005", parentId: null, level: "department", name: "Books",       icon: <FaBook /> },
  { id: "006", parentId: null, level: "department", name: "Electronics", icon: <FaLaptop /> },
  { id: "007", parentId: null, level: "department", name: "Farm",        icon: <FaTree /> },
  { id: "008", parentId: null, level: "department", name: "Apparallel",  icon: <FaShirt /> },
  { id: "009", parentId: null, level: "department", name: "Food",        icon: <FaMugSaucer /> },
  { id: "010", parentId: null, level: "department", name: "Furniture",   icon: <FaCouch /> },
  { id: "011", parentId: null, level: "department", name: "Gaming",      icon: <FaGamepad /> },
  { id: "012", parentId: null, level: "department", name: "Gifts",       icon: <FaGift /> },
  { id: "013", parentId: null, level: "department", name: "Grocery",     icon: <FaAppleWhole /> },
  { id: "014", parentId: null, level: "department", name: "Kitchen",     icon: <FaChair /> },
  { id: "015", parentId: null, level: "department", name: "Luggage",     icon: <FaSuitcase /> },
  { id: "016", parentId: null, level: "department", name: "Pets",        icon: <FaPaw /> },
  { id: "017", parentId: null, level: "department", name: "Restaurant",  icon: <FaBellConcierge /> },
  { id: "018", parentId: null, level: "department", name: "Sports",      icon: <FaFutbol /> },
  { id: "019", parentId: null, level: "department", name: "Tools",       icon: <FaScrewdriverWrench /> },
  { id: "020", parentId: null, level: "department", name: "Toys",        icon: <FaPuzzlePiece /> },
];


/* ═══════════════════════════════════════════════════════════
   DEPARTMENT-LEVEL CATEGORY ARRAYS
   id = deptId(3-digit) + 2-digit suffix (5 digits total)
   parentId = deptId (3-digit), level: "category"
═══════════════════════════════════════════════════════════ */

/* ── 000 ArtCrafts ────────────────────────────────────────── */
export const DEPARTMENTARTCRAFTSATTRIBUTES: CategoryItem[] = [
  { id: "00001", parentId: "000", level: "category", name: "Painting",                icon: <FaPalette /> },
  { id: "00002", parentId: "000", level: "category", name: "Drawing",                 icon: <FaPen /> },
  { id: "00003", parentId: "000", level: "category", name: "Sculpting & Pottery",     icon: <FaWandMagicSparkles /> },
  { id: "00004", parentId: "000", level: "category", name: "Craft Supplies",          icon: <FaBoxesStacked /> },
  { id: "00005", parentId: "000", level: "category", name: "Scrapbooking",            icon: <FaFolder /> },
  { id: "00006", parentId: "000", level: "category", name: "Sewing & Textile Crafts", icon: <FaScissors /> },
  { id: "00007", parentId: "000", level: "category", name: "Jewelry Making",          icon: <FaRing /> },
  { id: "00008", parentId: "000", level: "category", name: "Party & Paper Crafts",    icon: <FaGift /> },
];
export const DEPARTMENTARTCRAFTSTREE: CategoryItem = {
  id: "000",
  parentId: null,
  level: "department",
  name: "ArtCrafts",
  icon: <FaPalette />,
  attributes: [],
  children: DEPARTMENTARTCRAFTSATTRIBUTES,
};

/* ── 001 Automotive ──────────────────────────────────────── */
export const DEPARTMENTAUTOMOTIVEATTRIBUTES: CategoryItem[] = [
  { id: "00101", parentId: "001", level: "category", name: "Car Parts",           icon: <FaCarSide /> },
  { id: "00102", parentId: "001", level: "category", name: "Car Accessories",     icon: <FaCar /> },
  { id: "00103", parentId: "001", level: "category", name: "Car Care & Detailing", icon: <FaPumpSoap /> },
  { id: "00104", parentId: "001", level: "category", name: "Tires & Wheels",      icon: <FaCircleQuestion /> },
  { id: "00105", parentId: "001", level: "category", name: "Tools & Equipment",   icon: <FaScrewdriverWrench /> },
  { id: "00106", parentId: "001", level: "category", name: "Motorcycle Parts",    icon: <FaMotorcycle /> },
  { id: "00107", parentId: "001", level: "category", name: "Car Electronics",     icon: <FaCarBattery /> },
  { id: "00108", parentId: "001", level: "category", name: "Interior Accessories", icon: <FaChair /> },
  { id: "00109", parentId: "001", level: "category", name: "Exterior Accessories", icon: <FaCarSide /> },
  { id: "00110", parentId: "001", level: "category", name: "Oils & Fluids",       icon: <FaWineBottle /> },
];
export const DEPARTMENTAUTOMOTIVETREE: CategoryItem = {
  id: "001",
  parentId: null,
  level: "department",
  name: "Automotive",
  icon: <FaCar />,
  attributes: [],
  children: DEPARTMENTAUTOMOTIVEATTRIBUTES,
};

/* ── 002 Aviation ──────────────────────────────────────── */
export const DEPARTMENTAVIATIONATTRIBUTES: CategoryItem[] = [
  { id: "00201", parentId: "002", level: "category", name: "Pilot Supplies",      icon: <FaBriefcase /> },
  { id: "00202", parentId: "002", level: "category", name: "Aircraft Parts",      icon: <FaPlug /> },
  { id: "00203", parentId: "002", level: "category", name: "Aviation Electronics", icon: <FaLaptop /> },
  { id: "00204", parentId: "002", level: "category", name: "Model Aircraft",      icon: <FaPuzzlePiece /> },
  { id: "00205", parentId: "002", level: "category", name: "Aviation Safety Gear", icon: <FaHelmetSafety /> },
  { id: "00206", parentId: "002", level: "category", name: "Drones & UAVs",       icon: <FaCamera /> },
  { id: "00207", parentId: "002", level: "category", name: "Aviation Books & Charts", icon: <FaBook /> },
];
export const DEPARTMENTAVIATIONTREE: CategoryItem = {
  id: "002",
  parentId: null,
  level: "department",
  name: "Aviation",
  icon: <FaPlug />,
  attributes: [],
  children: DEPARTMENTAVIATIONATTRIBUTES,
};





/* ── 003 Baby ──────────────────────────────────────── */
export const DEPARTMENTBABYATTRIBUTES: CategoryItem[] = [
  { id: "00301", parentId: "003", level: "category", name: "Baby Clothing",   icon: <FaShirt /> },
  { id: "00302", parentId: "003", level: "category", name: "Baby Feeding",    icon: <FaMugSaucer /> },
  { id: "00303", parentId: "003", level: "category", name: "Baby Gear",       icon: <FaBabyCarriage /> },
  { id: "00304", parentId: "003", level: "category", name: "Nursery",         icon: <FaBed /> },
  { id: "00305", parentId: "003", level: "category", name: "Baby Bath & Skincare", icon: <FaPumpSoap /> },
  { id: "00306", parentId: "003", level: "category", name: "Diapering",       icon: <FaBaby /> },
  { id: "00307", parentId: "003", level: "category", name: "Baby Safety",     icon: <FaTriangleExclamation /> },
  { id: "00308", parentId: "003", level: "category", name: "Baby Toys",       icon: <FaPuzzlePiece /> },
  { id: "00309", parentId: "003", level: "category", name: "Maternity",       icon: <FaHeart /> },
];
export const DEPARTMENTBABYTREE: CategoryItem = {
  id: "003",
  parentId: null,
  level: "department",
  name: "Baby",
  icon: <FaBaby />,
  attributes: [],
  children: DEPARTMENTBABYATTRIBUTES,
};

/* ── 004 Beauty ──────────────────────────────────────── */
export const DEPARTMENTBEAUTYATTRIBUTES: CategoryItem[] = [
  { id: "00401", parentId: "004", level: "category", name: "Skincare",              icon: <FaSpa /> },
  { id: "00402", parentId: "004", level: "category", name: "Makeup",                icon: <FaPalette /> },
  { id: "00403", parentId: "004", level: "category", name: "Haircare",              icon: <FaScissors /> },
  { id: "00404", parentId: "004", level: "category", name: "Fragrance",             icon: <FaWineBottle /> },
  { id: "00405", parentId: "004", level: "category", name: "Bath & Body",           icon: <FaPumpSoap /> },
  { id: "00406", parentId: "004", level: "category", name: "Nail Care",             icon: <FaWandMagicSparkles /> },
  { id: "00407", parentId: "004", level: "category", name: "Men's Grooming",        icon: <FaScissors /> },
  { id: "00408", parentId: "004", level: "category", name: "Beauty Tools & Accessories", icon: <FaGem /> },
  { id: "00409", parentId: "004", level: "category", name: "Beauty Appliances",     icon: <FaPlug /> },
];
export const DEPARTMENTBEAUTYTREE: CategoryItem = {
  id: "004",
  parentId: null,
  level: "department",
  name: "Beauty",
  icon: <FaSpa />,
  attributes: [],
  children: DEPARTMENTBEAUTYATTRIBUTES,
};




/* ── 005 Books ──────────────────────────────────────── */
export const DEPARTMENTBOOKSATTRIBUTES: CategoryItem[] = [
  { id: "00501", parentId: "005", level: "category", name: "Fiction",                 icon: <FaBook /> },
  { id: "00502", parentId: "005", level: "category", name: "Non-Fiction",             icon: <FaBook /> },
  { id: "00503", parentId: "005", level: "category", name: "Children's Books",        icon: <FaChild /> },
  { id: "00504", parentId: "005", level: "category", name: "Educational & Textbooks", icon: <FaPen /> },
  { id: "00505", parentId: "005", level: "category", name: "Comics & Graphic Novels", icon: <FaMasksTheater /> },
  { id: "00506", parentId: "005", level: "category", name: "Cookbooks",               icon: <FaMugSaucer /> },
  { id: "00507", parentId: "005", level: "category", name: "Religious & Spiritual",   icon: <FaCross /> },
  { id: "00508", parentId: "005", level: "category", name: "Magazines",               icon: <FaFolder /> },
  { id: "00509", parentId: "005", level: "category", name: "eBooks & Audiobooks",     icon: <FaHeadphones /> },
];
export const DEPARTMENTBOOKSTREE: CategoryItem = {
  id: "005",
  parentId: null,
  level: "department",
  name: "Books",
  icon: <FaBook />,
  attributes: [],
  children: DEPARTMENTBOOKSATTRIBUTES,
};





/* ── 006 Electronics ──────────────────────────────────────── */
export const DEPARTMENTELECTRONICSATTRIBUTES: CategoryItem[] = [
  { id: "00601", parentId: "006", level: "category", name: "TV & Home Theater",     icon: <FaTv /> },
  { id: "00602", parentId: "006", level: "category", name: "IT & Computers",        icon: <FaLaptopCode /> },
  { id: "00603", parentId: "006", level: "category", name: "Telephone & Mobile",    icon: <FaMobileScreenButton /> },
  { id: "00604", parentId: "006", level: "category", name: "Audio",                 icon: <FaHeadphones /> },
  { id: "00605", parentId: "006", level: "category", name: "Home Appliances",       icon: <FaPlug /> },
  { id: "00606", parentId: "006", level: "category", name: "Kitchen Appliances",    icon: <FaMugSaucer /> },
  { id: "00607", parentId: "006", level: "category", name: "Beauty Appliances",     icon: <FaSpa /> },
  { id: "00608", parentId: "006", level: "category", name: "Entertainment",         icon: <FaGamepad /> },
  { id: "00609", parentId: "006", level: "category", name: "Gym Appliances",        icon: <FaDumbbell /> },
  { id: "00610", parentId: "006", level: "category", name: "Health Appliances",     icon: <FaCross /> },
  { id: "00611", parentId: "006", level: "category", name: "Film & Photography",    icon: <FaCamera /> },
  { id: "00612", parentId: "006", level: "category", name: "Mobility Appliances",   icon: <FaPersonRunning /> },
  { id: "00613", parentId: "006", level: "category", name: "Housekeeping Appliances", icon: <FaBoxesStacked /> },
];

export const DEPARTMENTELECTRONICSTREE: CategoryItem = {
  id: "006",
  parentId: null,
  level: "department",
  name: "Electronics",
  icon: <FaLaptop />,
  attributes: [
    {
      id: 60001,
      name: "Brand",
      options: [
        { id: 1, name: "Samsung" },
        { id: 2, name: "LG" },
        { id: 3, name: "Sony" },
        { id: 4, name: "Apple" },
        { id: 5, name: "Bosch" },
        { id: 6, name: "Philips" },
        { id: 7, name: "Panasonic" },
        { id: 8, name: "Dyson" },
        { id: 9, name: "Xiaomi" },
        { id: 10, name: "Generic / Other" },
      ],
    },
    {
      id: 60002,
      name: "Warranty",
      options: [
        { id: 1, name: "No Warranty" },
        { id: 2, name: "6 Months" },
        { id: 3, name: "1 Year" },
        { id: 4, name: "2 Years" },
        { id: 5, name: "3+ Years" },
      ],
    },
    {
      id: 60003,
      name: "Power / Voltage",
      options: [
        { id: 1, name: "110V" },
        { id: 2, name: "220V" },
        { id: 3, name: "110-240V (Dual)" },
        { id: 4, name: "Battery Powered" },
        { id: 5, name: "USB Powered" },
      ],
    },
  ],
  children: [
    {
      id: "00601",
      parentId: "006",
      level: "category",
      name: "TV & Home Theater",
      icon: <FaTv />,
      attributes: [
        {
          id: 600101,
          name: "Screen Size",
          options: [
            { id: 1, inches: "32", cm: "81" },
            { id: 2, inches: "43", cm: "109" },
            { id: 3, inches: "50", cm: "127" },
            { id: 4, inches: "55", cm: "140" },
            { id: 5, inches: "65", cm: "165" },
            { id: 6, inches: "75", cm: "191" },
            { id: 7, inches: "85", cm: "216" },
          ],
        },
        {
          id: 600102,
          name: "Resolution",
          options: [
            { id: 1, name: "HD" },
            { id: 2, name: "Full HD" },
            { id: 3, name: "4K UHD" },
            { id: 4, name: "8K" },
          ],
        },
        {
          id: 600103,
          name: "Display Type",
          options: [
            { id: 1, name: "LED" },
            { id: 2, name: "OLED" },
            { id: 3, name: "QLED" },
            { id: 4, name: "Mini-LED" },
          ],
        },
      ],
    },
    {
      id: "00602",
      parentId: "006",
      level: "category",
      name: "IT & Computers",
      icon: <FaLaptopCode />,
      attributes: [
        {
          id: 600201,
          name: "RAM",
          options: [
            { id: 1, name: "4GB" },
            { id: 2, name: "8GB" },
            { id: 3, name: "16GB" },
            { id: 4, name: "32GB" },
            { id: 5, name: "64GB+" },
          ],
        },
        {
          id: 600202,
          name: "Storage",
          options: [
            { id: 1, name: "128GB" },
            { id: 2, name: "256GB" },
            { id: 3, name: "512GB" },
            { id: 4, name: "1TB" },
            { id: 5, name: "2TB+" },
          ],
        },
        {
          id: 600203,
          name: "Processor",
          options: [
            { id: 1, name: "Intel Core i3" },
            { id: 2, name: "Intel Core i5" },
            { id: 3, name: "Intel Core i7" },
            { id: 4, name: "Intel Core i9" },
            { id: 5, name: "AMD Ryzen 5" },
            { id: 6, name: "AMD Ryzen 7" },
            { id: 7, name: "Apple M-Series" },
          ],
        },
      ],
    },
    {
      id: "00603",
      parentId: "006",
      level: "category",
      name: "Telephone & Mobile",
      icon: <FaMobileScreenButton />,
      attributes: [
        {
          id: 600301,
          name: "Storage",
          options: [
            { id: 1, name: "64GB" },
            { id: 2, name: "128GB" },
            { id: 3, name: "256GB" },
            { id: 4, name: "512GB" },
            { id: 5, name: "1TB" },
          ],
        },
        {
          id: 600302,
          name: "Screen Size",
          options: [
            { id: 1, inches: "Under 5.5" },
            { id: 2, inches: "5.5-6.3" },
            { id: 3, inches: "6.4-6.7" },
            { id: 4, inches: "6.8+" },
          ],
        },
        {
          id: 600303,
          name: "Network",
          options: [
            { id: 1, name: "4G" },
            { id: 2, name: "5G" },
            { id: 3, name: "Wi-Fi Only" },
          ],
        },
      ],
    },
    {
      id: "00604",
      parentId: "006",
      level: "category",
      name: "Audio",
      icon: <FaHeadphones />,
      attributes: [
        {
          id: 600401,
          name: "Type",
          options: [
            { id: 1, name: "Headphones" },
            { id: 2, name: "Earbuds" },
            { id: 3, name: "Speaker" },
            { id: 4, name: "Soundbar" },
            { id: 5, name: "Home Theater System" },
          ],
        },
        {
          id: 600402,
          name: "Connectivity",
          options: [
            { id: 1, name: "Wired" },
            { id: 2, name: "Bluetooth" },
            { id: 3, name: "Wi-Fi" },
            { id: 4, name: "Wired + Wireless" },
          ],
        },
      ],
    },
    {
      id: "00605",
      parentId: "006",
      level: "category",
      name: "Home Appliances",
      icon: <FaPlug />,
      attributes: [
        {
          id: 600501,
          name: "Type",
          options: [
            { id: 1, name: "Washing Machine" },
            { id: 2, name: "Refrigerator" },
            { id: 3, name: "Air Conditioner" },
            { id: 4, name: "Vacuum Cleaner" },
            { id: 5, name: "Water Heater" },
          ],
        },
        {
          id: 600502,
          name: "Energy Rating",
          options: [
            { id: 1, name: "A+++" },
            { id: 2, name: "A++" },
            { id: 3, name: "A+" },
            { id: 4, name: "A" },
            { id: 5, name: "B or below" },
          ],
        },
      ],
    },
    {
      id: "00606",
      parentId: "006",
      level: "category",
      name: "Kitchen Appliances",
      icon: <FaMugSaucer />,
      attributes: [
        {
          id: 600601,
          name: "Type",
          options: [
            { id: 1, name: "Microwave" },
            { id: 2, name: "Blender" },
            { id: 3, name: "Coffee Maker" },
            { id: 4, name: "Toaster" },
            { id: 5, name: "Air Fryer" },
            { id: 6, name: "Dishwasher" },
          ],
        },
        {
          id: 600602,
          name: "Capacity",
          options: [
            { id: 1, name: "Under 1L" },
            { id: 2, name: "1-3L" },
            { id: 3, name: "3-6L" },
            { id: 4, name: "6L+" },
          ],
        },
      ],
    },
    {
      id: "00607",
      parentId: "006",
      level: "category",
      name: "Beauty Appliances",
      icon: <FaSpa />,
      attributes: [
        {
          id: 600701,
          name: "Type",
          options: [
            { id: 1, name: "Hair Dryer" },
            { id: 2, name: "Hair Straightener" },
            { id: 3, name: "Electric Shaver" },
            { id: 4, name: "Epilator" },
            { id: 5, name: "Facial Cleanser" },
          ],
        },
      ],
    },
    {
      id: "00608",
      parentId: "006",
      level: "category",
      name: "Entertainment",
      icon: <FaGamepad />,
      attributes: [
        {
          id: 600801,
          name: "Type",
          options: [
            { id: 1, name: "Gaming Console" },
            { id: 2, name: "VR Headset" },
            { id: 3, name: "Streaming Device" },
            { id: 4, name: "Projector" },
          ],
        },
      ],
    },
    {
      id: "00609",
      parentId: "006",
      level: "category",
      name: "Gym Appliances",
      icon: <FaDumbbell />,
      attributes: [
        {
          id: 600901,
          name: "Type",
          options: [
            { id: 1, name: "Treadmill" },
            { id: 2, name: "Exercise Bike" },
            { id: 3, name: "Smartwatch / Fitness Tracker" },
            { id: 4, name: "Massage Gun" },
          ],
        },
      ],
    },
    {
      id: "00610",
      parentId: "006",
      level: "category",
      name: "Health Appliances",
      icon: <FaCross />,
      attributes: [
        {
          id: 601001,
          name: "Type",
          options: [
            { id: 1, name: "Blood Pressure Monitor" },
            { id: 2, name: "Thermometer" },
            { id: 3, name: "Nebulizer" },
            { id: 4, name: "Weighing Scale" },
          ],
        },
      ],
    },
    {
      id: "00611",
      parentId: "006",
      level: "category",
      name: "Film & Photography",
      icon: <FaCamera />,
      attributes: [
        {
          id: 601101,
          name: "Type",
          options: [
            { id: 1, name: "DSLR" },
            { id: 2, name: "Mirrorless" },
            { id: 3, name: "Action Camera" },
            { id: 4, name: "Instant Camera" },
          ],
        },
        {
          id: 601102,
          name: "Resolution",
          options: [
            { id: 1, name: "12MP" },
            { id: 2, name: "24MP" },
            { id: 3, name: "36MP" },
            { id: 4, name: "48MP+" },
          ],
        },
      ],
    },
    {
      id: "00612",
      parentId: "006",
      level: "category",
      name: "Mobility Appliances",
      icon: <FaPersonRunning />,
      attributes: [
        {
          id: 601201,
          name: "Type",
          options: [
            { id: 1, name: "Electric Scooter" },
            { id: 2, name: "Electric Bike" },
            { id: 3, name: "Hoverboard" },
            { id: 4, name: "Mobility Wheelchair" },
          ],
        },
      ],
    },
    {
      id: "00613",
      parentId: "006",
      level: "category",
      name: "Housekeeping Appliances",
      icon: <FaBoxesStacked />,
      attributes: [
        {
          id: 601301,
          name: "Type",
          options: [
            { id: 1, name: "Robot Vacuum" },
            { id: 2, name: "Steam Mop" },
            { id: 3, name: "Air Purifier" },
            { id: 4, name: "Dehumidifier" },
          ],
        },
      ],
    },
  ],
};




/* ── 007 Farm ──────────────────────────────────────── */
export const DEPARTMENTFARMATTRIBUTES: CategoryItem[] = [
  { id: "00701", parentId: "007", level: "category", name: "Livestock Supplies", icon: <FaDog /> },
  { id: "00702", parentId: "007", level: "category", name: "Farm Equipment",     icon: <FaTruck /> },
  { id: "00703", parentId: "007", level: "category", name: "Seeds & Plants",     icon: <FaSeedling /> },
  { id: "00704", parentId: "007", level: "category", name: "Irrigation",        icon: <FaWind /> },
  { id: "00705", parentId: "007", level: "category", name: "Poultry Supplies",  icon: <FaFish /> },
  { id: "00706", parentId: "007", level: "category", name: "Farm Safety Gear",  icon: <FaHelmetSafety /> },
  { id: "00707", parentId: "007", level: "category", name: "Feed & Nutrition",  icon: <FaAppleWhole /> },
];
export const DEPARTMENTFARMTREE: CategoryItem = {
  id: "007",
  parentId: null,
  level: "department",
  name: "Farm",
  icon: <FaTractor />,
  attributes: [],
  children: DEPARTMENTFARMATTRIBUTES,
};

/* ═══════════════════════════════════════════════════════════
   008 APPARALLEL — FULLY MAPPED
   dept attrs: Material, Gender (all apparel)
   category attrs: Clothing→Size/Fit, Shoes→Shoe Size,
                   Accessories→Type, Jewelry→Metal/Gemstone, Bags→Size
═══════════════════════════════════════════════════════════ */
export const DEPARTMENTAPPARELTREE: CategoryItem = {
  id: "008", parentId: null, level: "department", name: "Apparallel", icon: <FaShirt />,
  attributes: [
    {
      id: 80001,
      name: "Material",
      options: [
        { id: 1, name: "Cotton" },
        { id: 2, name: "Polyester" },
        { id: 3, name: "Wool" },
        { id: 4, name: "Denim" },
        { id: 5, name: "Leather" },
        { id: 6, name: "Canvas" },
        { id: 7, name: "Mesh" },
        { id: 8, name: "Suede" },
        { id: 9, name: "Nylon" },
        { id: 10, name: "Gold" },
        { id: 11, name: "Silver" },
        { id: 12, name: "Platinum" },
      ],
    },
    {
      id: 80002,
      name: "Size",
      options: [
        { id: 1, standard: "XS",  eu: "32", uk: "4",  us: "0",  waist: "24-25", hips: "34-35", height: "160-165", inseam: "30" },
        { id: 2, standard: "S",   eu: "34", uk: "6",  us: "2",  waist: "26-27", hips: "36-37", height: "160-168", inseam: "30" },
        { id: 3, standard: "M",   eu: "36", uk: "8",  us: "4",  waist: "28-29", hips: "38-39", height: "163-170", inseam: "31" },
        { id: 4, standard: "L",   eu: "38", uk: "10", us: "6",  waist: "30-31", hips: "40-41", height: "165-172", inseam: "31" },
        { id: 5, standard: "XL",  eu: "40", uk: "12", us: "8",  waist: "32-34", hips: "42-44", height: "168-175", inseam: "32" },
        { id: 6, standard: "XXL", eu: "42", uk: "14", us: "10", waist: "35-37", hips: "45-47", height: "170-178", inseam: "32" },
      ],
    },
    {
      id: 80003, name: "Gender", inputType: "select",
      options: [
        { id: 1, name: "Men" }, { id: 2, name: "Women" }, { id: 3, name: "Unisex" }, { id: 4, name: "Kids" },
      ],
    },
  ],
  children: [
    {
      id: "00801", parentId: "008", level: "category", name: "Clothing", icon: <FaShirt />,
      attributes: [
        { id: 80101, name: "Size", inputType: "select", required: true },
        {
          id: 80102, name: "Fit", inputType: "select",
          options: [
            { id: 1, name: "Slim" }, { id: 2, name: "Regular" },
            { id: 3, name: "Relaxed" }, { id: 4, name: "Oversized" },
          ],
        },
      ],
    },
    {
      id: "00802", parentId: "008", level: "category", name: "Shoes", icon: <FaShoePrints />,
      attributes: [
        {
          id: 80201, name: "Shoe Size", inputType: "select", required: true,
          options: [
            { id: 1, standard: "EU 36", eu: "36", uk: "3",   us: "5" },
            { id: 2, standard: "EU 38", eu: "38", uk: "5",   us: "7" },
            { id: 3, standard: "EU 40", eu: "40", uk: "6.5", us: "8.5" },
            { id: 4, standard: "EU 42", eu: "42", uk: "8",   us: "9.5" },
            { id: 5, standard: "EU 44", eu: "44", uk: "9.5", us: "11" },
            { id: 6, standard: "EU 46", eu: "46", uk: "11",  us: "12.5" },
          ],
        },
      ],
    },
    {
      id: "00803", parentId: "008", level: "category", name: "Accessories", icon: <FaGem />,
      attributes: [
        {
          id: 80301, name: "Type", inputType: "select",
          options: [
            { id: 1, name: "Belts" }, { id: 2, name: "Hats" },
            { id: 3, name: "Scarves" }, { id: 4, name: "Sunglasses" }, { id: 5, name: "Gloves" },
          ],
        },
      ],
    },
    {
      id: "00804", parentId: "008", level: "category", name: "Jewelry", icon: <FaRing />,
      attributes: [
        {
          id: 80401, name: "Metal", inputType: "select",
          options: [
            { id: 1, name: "Gold" }, { id: 2, name: "Silver" },
            { id: 3, name: "Platinum" }, { id: 4, name: "Stainless Steel" }, { id: 5, name: "Titanium" },
          ],
        },
        {
          id: 80402, name: "Gemstone", inputType: "select",
          options: [
            { id: 1, name: "Diamond" }, { id: 2, name: "Sapphire" },
            { id: 3, name: "Ruby" }, { id: 4, name: "Emerald" }, { id: 5, name: "None" },
          ],
        },
      ],
    },
    {
      id: "00805", parentId: "008", level: "category", name: "Bags", icon: <FaBagShopping />,
      attributes: [
        {
          id: 80501, name: "Size", inputType: "select",
          options: [
            { id: 1, name: "Mini" }, { id: 2, name: "Small" },
            { id: 3, name: "Medium" }, { id: 4, name: "Large" },
          ],
        },
      ],
    },
  ],
};



/* ── 009 Food ──────────────────────────────────────── */
/* ═══════════════════════════════════════════════════════════
   009 FOOD — FULLY MAPPED
   dept attrs: Dietary, Allergens, Storage, Net Quantity (all food)
   category attrs: Farm Produce→Growing/Harvest,
                   Fast Food→Serving/Temperature,
                   Grocery→Processing/Shelf
═══════════════════════════════════════════════════════════ */
export const DEPARTMENTFOODTREE: CategoryItem = {
  id: "009", parentId: null, level: "department", name: "Food", icon: <FaUtensils />,
  attributes: [
    {
      id: 91001, name: "Dietary", inputType: "multiselect",
      options: [
        { id: 1, name: "Vegetarian" }, { id: 2, name: "Vegan" }, { id: 3, name: "Halal" },
        { id: 4, name: "Kosher" }, { id: 5, name: "Gluten-Free" }, { id: 6, name: "Lactose-Free" },
        { id: 7, name: "Sugar-Free" }, { id: 8, name: "Keto" },
      ],
    },
    {
      id: 91002, name: "Allergens", inputType: "multiselect",
      options: [
        { id: 1, name: "Gluten" }, { id: 2, name: "Dairy" }, { id: 3, name: "Eggs" },
        { id: 4, name: "Nuts" }, { id: 5, name: "Peanuts" }, { id: 6, name: "Soy" },
        { id: 7, name: "Fish" }, { id: 8, name: "Shellfish" }, { id: 9, name: "Sesame" },
        { id: 10, name: "Celery" }, { id: 11, name: "Mustard" }, { id: 12, name: "Sulphites" },
      ],
    },
    {
      id: 91003, name: "Storage", inputType: "select",
      options: [
        { id: 1, name: "Ambient" }, { id: 2, name: "Chilled" },
        { id: 3, name: "Frozen" }, { id: 4, name: "Deep Frozen" },
      ],
    },
    { id: 91004, name: "Net Quantity", inputType: "number", options: [] },
    { id: 91005, name: "Shelf Life",   inputType: "number", unit: "days", options: [] },
  ],
  children: [
    {
      id: "00901", parentId: "009", level: "category", name: "Farm Produce", icon: <FaTractor />,
      attributes: [
        {
          id: 91101, name: "Growing Method", inputType: "select", required: true,
          options: [
            { id: 1, name: "Organic" }, { id: 2, name: "Conventional" }, { id: 3, name: "Biodynamic" },
            { id: 4, name: "Hydroponic" }, { id: 5, name: "Free Range" }, { id: 6, name: "Wild" },
          ],
        },
        {
          id: 91102, name: "Ripeness", inputType: "select",
          options: [
            { id: 1, name: "Unripe" }, { id: 2, name: "Ready to Eat" }, { id: 3, name: "Ripen at Home" },
          ],
        },
        {
          id: 91103, name: "Grade", inputType: "select",
          options: [
            { id: 1, name: "Class I" }, { id: 2, name: "Class II" },
            { id: 3, name: "Wonky / Imperfect" }, { id: 4, name: "Premium" },
          ],
        },
        { id: 91104, name: "Origin", inputType: "text", options: [] },
        { id: 91105, name: "Harvest Date", inputType: "text", options: [] },
      ],
    },
    {
      id: "00902", parentId: "009", level: "category", name: "Fast Food", icon: <FaTruckFast />,
      attributes: [
        {
          id: 91201, name: "Serving Size", inputType: "select", required: true,
          options: [
            { id: 1, name: "Regular" }, { id: 2, name: "Large" },
            { id: 3, name: "Sharing" }, { id: 4, name: "Kids" },
          ],
        },
        {
          id: 91202, name: "Serve Temperature", inputType: "select",
          options: [
            { id: 1, name: "Hot" }, { id: 2, name: "Cold" }, { id: 3, name: "Room Temperature" },
          ],
        },
        {
          id: 91203, name: "Spice Level", inputType: "select",
          options: [
            { id: 1, name: "None" }, { id: 2, name: "Mild" },
            { id: 3, name: "Medium" }, { id: 4, name: "Hot" }, { id: 5, name: "Extra Hot" },
          ],
        },
        {
          id: 91204, name: "Cooking Method", inputType: "select",
          options: [
            { id: 1, name: "Grilled" }, { id: 2, name: "Fried" }, { id: 3, name: "Baked" },
            { id: 4, name: "Steamed" }, { id: 5, name: "Raw" }, { id: 6, name: "Roasted" },
          ],
        },
        { id: 91205, name: "Prep Time", inputType: "number", unit: "min", options: [] },
      ],
    },
    {
      id: "00903", parentId: "009", level: "category", name: "Grocery", icon: <FaCartShopping />,
      attributes: [
        {
          id: 91301, name: "Processing", inputType: "select", required: true,
          options: [
            { id: 1, name: "Raw" }, { id: 2, name: "Pasteurised" }, { id: 3, name: "Cured" },
            { id: 4, name: "Smoked" }, { id: 5, name: "Canned" }, { id: 6, name: "Dried" },
            { id: 7, name: "Fermented" }, { id: 8, name: "Ready Meal" },
          ],
        },
        {
          id: 91302, name: "Form", inputType: "select",
          options: [
            { id: 1, name: "Whole" }, { id: 2, name: "Sliced" }, { id: 3, name: "Ground" },
            { id: 4, name: "Powder" }, { id: 5, name: "Paste" }, { id: 6, name: "Liquid" },
          ],
        },
        {
          id: 91303, name: "Certification", inputType: "multiselect",
          options: [
            { id: 1, name: "Organic" }, { id: 2, name: "Fairtrade" }, { id: 3, name: "Non-GMO" },
            { id: 4, name: "PDO / PGI" }, { id: 5, name: "MSC / ASC" },
          ],
        },
        {
          id: 91304, name: "Pack Format", inputType: "select",
          options: [
            { id: 1, name: "Single" }, { id: 2, name: "Multipack" },
            { id: 3, name: "Family" }, { id: 4, name: "Bulk" },
          ],
        },
        { id: 91305, name: "Brand", inputType: "text", options: [] },
      ],
    },
  ],
};


/* ── 010 Furniture ──────────────────────────────────────── */
export const DEPARTMENTFURNITUREATTRIBUTES: CategoryItem[] = [
  { id: "01001", parentId: "010", level: "category", name: "Living Room", icon: <FaCouch /> },
  { id: "01002", parentId: "010", level: "category", name: "Bedroom",     icon: <FaBed /> },
  { id: "01003", parentId: "010", level: "category", name: "Dining Room", icon: <FaChair /> },
  { id: "01004", parentId: "010", level: "category", name: "Office Furniture", icon: <FaBriefcase /> },
  { id: "01005", parentId: "010", level: "category", name: "Outdoor Furniture", icon: <FaUmbrellaBeach /> },
  { id: "01006", parentId: "010", level: "category", name: "Storage",     icon: <FaBoxesStacked /> },
  { id: "01007", parentId: "010", level: "category", name: "Kids Furniture", icon: <FaChild /> },
];
export const DEPARTMENTFURNITURETREE: CategoryItem = {
  id: "010",
  parentId: null,
  level: "department",
  name: "Furniture",
  icon: <FaCouch />,
  attributes: [],
  children: DEPARTMENTFURNITUREATTRIBUTES,
};


/* ── 011 Gaming ──────────────────────────────────────── */
export const DEPARTMENTGAMINGATTRIBUTES: CategoryItem[] = [
  { id: "01101", parentId: "011", level: "category", name: "Video Games",        icon: <FaGamepad /> },
  { id: "01102", parentId: "011", level: "category", name: "Gaming Consoles",    icon: <FaTv /> },
  { id: "01103", parentId: "011", level: "category", name: "Gaming Accessories", icon: <FaHeadphones /> },
  { id: "01104", parentId: "011", level: "category", name: "PC Gaming",          icon: <FaLaptopCode /> },
  { id: "01105", parentId: "011", level: "category", name: "Board Games",        icon: <FaChess /> },
  { id: "01106", parentId: "011", level: "category", name: "Card Games",         icon: <FaSquarePlus /> },
  { id: "01107", parentId: "011", level: "category", name: "VR Gaming",          icon: <FaVideo /> },
];
export const DEPARTMENTGAMINGTREE: CategoryItem = {
  id: "011",
  parentId: null,
  level: "department",
  name: "Gaming",
  icon: <FaGamepad />,
  attributes: [],
  children: DEPARTMENTGAMINGATTRIBUTES,
};

/* ── 012 Gifts ──────────────────────────────────────── */
export const DEPARTMENTGIFTSATTRIBUTES: CategoryItem[] = [
  { id: "01201", parentId: "012", level: "category", name: "Gift Cards",             icon: <FaGift /> },
  { id: "01202", parentId: "012", level: "category", name: "Personalized Gifts",     icon: <FaWandMagicSparkles /> },
  { id: "01203", parentId: "012", level: "category", name: "Gift Sets",              icon: <FaBoxesStacked /> },
  { id: "01204", parentId: "012", level: "category", name: "Occasion Gifts",         icon: <FaStar /> },
  { id: "01205", parentId: "012", level: "category", name: "Gift Wrap & Accessories", icon: <FaTag /> },
];
export const DEPARTMENTGIFTSTREE: CategoryItem = {
  id: "012",
  parentId: null,
  level: "department",
  name: "Gifts",
  icon: <FaGift />,
  attributes: [],
  children: DEPARTMENTGIFTSATTRIBUTES,
};

/* ── 013 Grocery ──────────────────────────────────────── */
export const DEPARTMENTGROCERYATTRIBUTES: CategoryItem[] = [
  { id: "01301", parentId: "013", level: "category", name: "Fresh Produce",       icon: <FaAppleWhole /> },
  { id: "01302", parentId: "013", level: "category", name: "Pantry Staples",      icon: <FaBoxesStacked /> },
  { id: "01303", parentId: "013", level: "category", name: "Household Supplies",  icon: <FaPumpSoap /> },
  { id: "01304", parentId: "013", level: "category", name: "Beverages",           icon: <FaWineBottle /> },
  { id: "01305", parentId: "013", level: "category", name: "Snacks",              icon: <FaCookieBite /> },
  { id: "01306", parentId: "013", level: "category", name: "Baby Food",           icon: <FaBaby /> },
];
export const DEPARTMENTGROCERYTREE: CategoryItem = {
  id: "013",
  parentId: null,
  level: "department",
  name: "Grocery",
  icon: <FaCartShopping />,
  attributes: [],
  children: DEPARTMENTGROCERYATTRIBUTES,
};

/* ── 014 Kitchen ──────────────────────────────────────── */
export const DEPARTMENTKITCHENATTRIBUTES: CategoryItem[] = [
  { id: "01401", parentId: "014", level: "category", name: "Cookware",                  icon: <FaChair /> },
  { id: "01402", parentId: "014", level: "category", name: "Bakeware",                  icon: <FaCookieBite /> },
  { id: "01403", parentId: "014", level: "category", name: "Kitchen Utensils",          icon: <FaScrewdriver /> },
  { id: "01404", parentId: "014", level: "category", name: "Small Kitchen Appliances",  icon: <FaPlug /> },
  { id: "01405", parentId: "014", level: "category", name: "Tableware",                 icon: <FaMugSaucer /> },
  { id: "01406", parentId: "014", level: "category", name: "Storage & Organization",    icon: <FaBoxesStacked /> },
  { id: "01407", parentId: "014", level: "category", name: "Cutlery",                   icon: <FaScissors /> },
];
export const DEPARTMENTKITCHENTREE: CategoryItem = {
  id: "014",
  parentId: null,
  level: "department",
  name: "Kitchen",
  icon: <FaKitchenSet />,
  attributes: [],
  children: DEPARTMENTKITCHENATTRIBUTES,
};

/* ── 015 Luggage ──────────────────────────────────────── */
export const DEPARTMENTLUGGAGEATTRIBUTES: CategoryItem[] = [
  { id: "01501", parentId: "015", level: "category", name: "Suitcases",         icon: <FaSuitcaseRolling /> },
  { id: "01502", parentId: "015", level: "category", name: "Travel Bags",       icon: <FaSuitcase /> },
  { id: "01503", parentId: "015", level: "category", name: "Backpacks",         icon: <FaBagShopping /> },
  { id: "01504", parentId: "015", level: "category", name: "Travel Accessories", icon: <FaTag /> },
  { id: "01505", parentId: "015", level: "category", name: "Garment Bags",      icon: <FaShirt /> },
];
export const DEPARTMENTLUGGAGETREE: CategoryItem = {
  id: "015",
  parentId: null,
  level: "department",
  name: "Luggage",
  icon: <FaSuitcaseRolling />,
  attributes: [],
  children: DEPARTMENTLUGGAGEATTRIBUTES,
};



/* ── 016 Pets ──────────────────────────────────────── */
export const DEPARTMENTPETSATTRIBUTES: CategoryItem[] = [
  { id: "01601", parentId: "016", level: "category", name: "Dog Supplies",         icon: <FaDog /> },
  { id: "01602", parentId: "016", level: "category", name: "Cat Supplies",         icon: <FaCat /> },
  { id: "01603", parentId: "016", level: "category", name: "Fish & Aquatics",      icon: <FaFish /> },
  { id: "01604", parentId: "016", level: "category", name: "Bird Supplies",        icon: <FaDove /> },
  { id: "01605", parentId: "016", level: "category", name: "Small Animal Supplies", icon: <FaPaw /> },
  { id: "01606", parentId: "016", level: "category", name: "Pet Food",             icon: <FaBone /> },
  { id: "01607", parentId: "016", level: "category", name: "Pet Health & Wellness", icon: <FaCross /> },
];
export const DEPARTMENTPETSTREE: CategoryItem = {
  id: "016",
  parentId: null,
  level: "department",
  name: "Pets",
  icon: <FaPaw />,
  attributes: [],
  children: DEPARTMENTPETSATTRIBUTES,
};



/* ── 017 Restaurant ──────────────────────────────────────── */
export const DEPARTMENTRESTAURANTATTRIBUTES: CategoryItem[] = [
  { id: "01701", parentId: "017", level: "category", name: "Kitchen Equipment",     icon: <FaChair /> },
  { id: "01702", parentId: "017", level: "category", name: "Tableware & Serveware", icon: <FaMugSaucer /> },
  { id: "01703", parentId: "017", level: "category", name: "Restaurant Furniture",  icon: <FaCouch /> },
  { id: "01704", parentId: "017", level: "category", name: "Uniforms",              icon: <FaShirt /> },
  { id: "01705", parentId: "017", level: "category", name: "POS & Technology",      icon: <FaLaptop /> },
];
export const DEPARTMENTRESTAURANTTREE: CategoryItem = {
  id: "017",
  parentId: null,
  level: "department",
  name: "Restaurant",
  icon: <FaUtensils />,
  attributes: [],
  children: DEPARTMENTRESTAURANTATTRIBUTES,
};

/* ── 018 Sports ──────────────────────────────────────── */
export const DEPARTMENTSPORTSATTRIBUTES: CategoryItem[] = [
  { id: "01801", parentId: "018", level: "category", name: "Team Sports",        icon: <FaFutbol /> },
  { id: "01802", parentId: "018", level: "category", name: "Fitness & Exercise", icon: <FaDumbbell /> },
  { id: "01803", parentId: "018", level: "category", name: "Outdoor Recreation", icon: <FaCampground /> },
  { id: "01804", parentId: "018", level: "category", name: "Cycling",            icon: <FaPersonBiking /> },
  { id: "01805", parentId: "018", level: "category", name: "Water Sports",       icon: <FaPersonSwimming /> },
  { id: "01806", parentId: "018", level: "category", name: "Winter Sports",      icon: <FaSnowflake /> },
  { id: "01807", parentId: "018", level: "category", name: "Sports Apparel",     icon: <FaShirt /> },
];
export const DEPARTMENTSPORTSTREE: CategoryItem = {
  id: "018",
  parentId: null,
  level: "department",
  name: "Sports",
  icon: <FaFutbol />,
  attributes: [],
  children: DEPARTMENTSPORTSATTRIBUTES,
};



/* ── 019 Tools ──────────────────────────────────────── */
export const DEPARTMENTTOOLSATTRIBUTES: CategoryItem[] = [
  { id: "01901", parentId: "019", level: "category", name: "Hand Tools",       icon: <FaHammer /> },
  { id: "01902", parentId: "019", level: "category", name: "Power Tools",      icon: <FaScrewdriverWrench /> },
  { id: "01903", parentId: "019", level: "category", name: "Tool Storage",     icon: <FaBoxesStacked /> },
  { id: "01904", parentId: "019", level: "category", name: "Measuring Tools",  icon: <FaWrench /> },
  { id: "01905", parentId: "019", level: "category", name: "Safety Equipment", icon: <FaHelmetSafety /> },
  { id: "01906", parentId: "019", level: "category", name: "Plumbing Tools",   icon: <FaWrench /> },
  { id: "01907", parentId: "019", level: "category", name: "Electrical Tools", icon: <FaBolt /> },
];
export const DEPARTMENTTOOLSTREE: CategoryItem = {
  id: "019",
  parentId: null,
  level: "department",
  name: "Tools",
  icon: <FaScrewdriverWrench />,
  attributes: [],
  children: DEPARTMENTTOOLSATTRIBUTES,
};


/* ── 020 Toys ──────────────────────────────────────── */
export const DEPARTMENTTOYSATTRIBUTES: CategoryItem[] = [
  { id: "02001", parentId: "020", level: "category", name: "Action Figures",     icon: <FaChild /> },
  { id: "02002", parentId: "020", level: "category", name: "Building Toys",      icon: <FaPuzzlePiece /> },
  { id: "02003", parentId: "020", level: "category", name: "Educational Toys",   icon: <FaBook /> },
  { id: "02004", parentId: "020", level: "category", name: "Dolls",              icon: <FaChild /> },
  { id: "02005", parentId: "020", level: "category", name: "Outdoor Toys",       icon: <FaUmbrellaBeach /> },
  { id: "02006", parentId: "020", level: "category", name: "Puzzles & Games",    icon: <FaPuzzlePiece /> },
  { id: "02007", parentId: "020", level: "category", name: "Remote Control Toys", icon: <FaGamepad /> },
];
export const DEPARTMENTTOYSTREE: CategoryItem = {
  id: "020",
  parentId: null,
  level: "department",
  name: "Toys",
  icon: <FaPuzzlePiece />,
  attributes: [],
  children: DEPARTMENTTOYSATTRIBUTES,
};


/* ═══════════════════════════════════════════════════════════
   ROOT — all departments in one nested tree (import THIS one).
═══════════════════════════════════════════════════════════ */
export const DEPARTMENTS_ATTR_TREE: CategoryItem[] = [
  DEPARTMENTARTCRAFTSTREE,
  DEPARTMENTAUTOMOTIVETREE,
  DEPARTMENTAVIATIONTREE,
  DEPARTMENTBABYTREE,
  DEPARTMENTBEAUTYTREE,
  DEPARTMENTBOOKSTREE,
  DEPARTMENTELECTRONICSTREE,
  DEPARTMENTFARMTREE,
  DEPARTMENTAPPARELTREE,
  DEPARTMENTFOODTREE,
  DEPARTMENTFURNITURETREE,
  DEPARTMENTGAMINGTREE,
  DEPARTMENTGIFTSTREE,
  DEPARTMENTGROCERYTREE,
  DEPARTMENTKITCHENTREE,
  DEPARTMENTLUGGAGETREE,
  DEPARTMENTPETSTREE,
  DEPARTMENTRESTAURANTTREE,
  DEPARTMENTSPORTSTREE,
  DEPARTMENTTOOLSTREE,
  DEPARTMENTTOYSTREE,
];





const asOptions = (arr: any[]) => arr.map((x) => ({ id: x.id, name: x.name }));

export const ATTR_COLOR: Attribute = {
  id: 90001, name: "Color", inputType: "color",
  options: Colors.map((c) => ({ id: c.id, name: c.name, hex: c.hexCodes?.[0] })),
};
export const ATTR_PACKAGING: Attribute = { id: 90002, name: "Packaging", inputType: "select", options: asOptions(PackagingTypes) };
export const ATTR_AGE:       Attribute = { id: 90003, name: "Age range", inputType: "select", options: asOptions(AgeRanges) };
export const ATTR_UNIT:      Attribute = {
  id: 90004, name: "Unit of measure", inputType: "select",
  options: Units.flatMap((g) =>
    g.units.map((u) => ({ id: u.id, name: u.symbol ? `${u.name} (${u.symbol})` : u.name, symbol: u.symbol }))
  ),
};

const UNIVERSAL: Attribute[] = [ATTR_COLOR];
const DEPT_EXTRAS: Record<string, Attribute[]> = {
  "003": [ATTR_AGE],
  "020": [ATTR_AGE],
  "008": [ATTR_AGE],
  "009": [ATTR_PACKAGING, ATTR_UNIT],
  "013": [ATTR_PACKAGING, ATTR_UNIT],
  "004": [ATTR_PACKAGING, ATTR_UNIT],
};

export const findNodePath = (
  id: string,
  forest: CategoryItem[] = DEPARTMENTS_ATTR_TREE
): CategoryItem[] | null => {
  const walk = (nodes: CategoryItem[], trail: CategoryItem[]): CategoryItem[] | null => {
    for (const n of nodes) {
      const next = [...trail, n];
      if (n.id === id) return next;
      if (n.children?.length) {
        const hit = walk(n.children, next);
        if (hit) return hit;
      }
    }
    return null;
  };
  return walk(forest, []);
};

/** Just the node. */
export const findNode = (
  id: string,
  forest: CategoryItem[] = DEPARTMENTS_ATTR_TREE
): CategoryItem | null => {
  const path = findNodePath(id, forest);
  return path ? path[path.length - 1] : null;
};

/** All attributes that apply to a category id: each ancestor's own
    attributes from root → node. On duplicate attribute NAME, the
    deepest (most specific) node wins and is ordered first. */
export const attributesForCategory = (
  categoryId: string | null | undefined,
  forest: CategoryItem[] = DEPARTMENTS_ATTR_TREE
): Attribute[] => {
  const path = categoryId ? findNodePath(categoryId, forest) : null;
  if (!path) return [];

  const byName = new Map<string, Attribute>();

  for (let i = path.length - 1; i >= 0; i--) {
    for (const a of path[i].attributes ?? []) {
      const hit = byName.get(a.name);
      if (!hit) byName.set(a.name, { ...a });
      else {
        if (!hit.options?.length && a.options?.length) hit.options = a.options;
        if (!hit.unit && a.unit) hit.unit = a.unit;
      }
    }
  }

  const deptId = path[0]?.id;
  for (const a of [...(DEPT_EXTRAS[deptId] ?? []), ...UNIVERSAL]) {
    if (!byName.has(a.name)) byName.set(a.name, { ...a });
  }

  return [...byName.values()];
};

/** Required attributes only (for validation before publish). */
export const requiredAttributesForCategory = (
  categoryId: string | null | undefined,
  forest: CategoryItem[] = DEPARTMENTS_ATTR_TREE
): Attribute[] => attributesForCategory(categoryId, forest).filter((a) => a.required);